
import { Link } from 'react-router-dom';

export default function GalleryFooter() {
  return (
    <footer className="bg-[#010E31] text-white py-8 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="border-t border-white/10 pt-6 md:pt-8">
          <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-center">
            {/* Left - Copyright */}
            <div className="text-center md:text-left">
              <p className="text-sm md:text-base text-white/80">© 2026 Alumi Innova - Todos os direitos reservados.</p>
            </div>

            {/* Center - Social Icons */}
            <div className="flex justify-center space-x-4">
              <a
                href="https://www.instagram.com/alumi_innova/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-[#C0C0C0] flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg md:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/alumi_innova/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-[#C0C0C0] flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg md:text-xl"></i>
              </a>
            </div>

            {/* Right - Links */}
            <div className="flex justify-center md:justify-end gap-4">
              <Link
                to="/"
                className="text-white/80 hover:text-[#C0C0C0] transition-colors whitespace-nowrap text-xs md:text-sm"
              >
                Início
              </Link>
              <span className="text-white/40">|</span>
              <Link
                to="/galeria"
                className="text-white/80 hover:text-[#C0C0C0] transition-colors whitespace-nowrap text-xs md:text-sm"
              >
                Galeria
              </Link>
            </div>
          </div>

          {/* Bottom Link */}
          <div className="mt-6 md:mt-8 pt-4 md:pt-6 border-t border-white/10 text-center">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs md:text-sm text-white/60 hover:text-[#C0C0C0] transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
